var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2485",
    d: "M14.0479 7.15234C13.3695 7.53397 13.0298 8.26981 12.4086 8.72378C12.0267 9.00284 11.6953 9.43727 11.3416 9.7714C11.0643 10.0333 10.798 10.3247 10.5219 10.6008C9.67304 11.4496 8.85769 12.3426 8.00469 13.1956C7.9471 13.2532 7.26003 14.0284 7.29657 14.0686C7.6567 14.4647 8.10513 14.7536 8.3733 15.2229C8.70039 15.7953 9.27965 16.2416 9.59552 16.7943C9.74135 17.0495 10.0236 17.1815 10.2066 17.4103C10.4739 17.7444 10.8967 18.2234 11.2543 18.4337C11.5325 18.5973 11.7364 18.8791 11.9721 19.0933C12.2697 19.3639 12.6632 19.6298 12.913 19.9421C13.0672 20.1348 13.3519 20.3889 13.5629 20.5095C13.908 20.7067 14.1169 21.1115 14.4844 21.2952",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2486",
    d: "M7.58765 13.875C12.3733 13.875 17.1937 13.9623 21.9925 13.9623",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.e37f04d6ff446470c0b8ece7f1ddcc84.svg";
export { ForwardRef as ReactComponent };